module.exports = {"rows_per_page":"عدد النتائج كل صفحة","out_of_pages":"من أصل","all":"الكل","__is_rtl":true,"search_data":"Search data"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-materialize-datatable/src/locales/ar.json
// module id = Y2eE
// module chunks = 1